/**
 * This file mirrors Airspace.Server/Common/WellKnownValues.cs
 * Keep these values in sync with the C# file
 */

export class BookingStatus {
    static readonly Pending = "Pending";
    static readonly Confirmed = "Confirmed";
    static readonly Cancelled = "Cancelled";
    static readonly Completed = "Completed";
}

export class PaymentStatus {
    static readonly Incomplete = "Incomplete";
    static readonly Completed = "Completed";
    static readonly Refunded = "Refunded";
    static readonly Processing = "Processing";
}

export class BookingType {
    static readonly Reservation = 0;
    static readonly Tour = 1;
    static readonly ReservationText = "Reservation";
    static readonly TourText = "Tour";
}

// Export a namespace for convenience
export const WellKnownValues = {
    BookingStatus,
    PaymentStatus,
    BookingType
};
